export default __webpack_public_path__ + "static/media/nike.e2c62a28.jpg";